<template>
  <v-container :class="($vuetify.breakpoint.xs) ? 'pa-0' : '' ">
    <v-app-bar app color="primary" dark >
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title v-text="$store.state.pageTitle"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark class='primary darken-2' icon @click="createUser()">
        <v-icon >mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <v-card tile flat>
      <v-card-text>
        <v-row class="mb-3">
          <v-col xs="12" sm="4" cols="12">

            <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined :value="orderDateFormat" label="Order date" readonly v-bind="attrs" v-on="on">
                </v-text-field>
              </template>
              <v-date-picker no-title v-model="order.date" @change="datePicker = false"></v-date-picker>
            </v-menu>

            <v-select dense label="Courier" outlined :items="couriers" v-model="order.courier"></v-select>
            <v-text-field dense outlined label="Code Booking" v-model="order.booking"></v-text-field>

          </v-col>

          <v-col xs="12" sm="6" offset-sm="2" cols="12">
            <v-autocomplete outlined dense :items="filteredUsers" v-model="order.User" return-object label="Customer" item-value="id" item-text="UserProfile.name" v-if="!order.User.id" hide-details @change="getUserId(order.User.id)" class="mb-3">
            </v-autocomplete>
            <div v-else class="mb-3">
              <div class="font-weight-bold">Customer:</div>
              <div class="font-weight-bold">{{ order.User.UserProfile.name }}</div>
              <div>{{ order.User.UserProfile.address }}, {{ order.User.UserProfile.city.city }}
                <span v-if="order.User.UserProfile.postCode">, {{ order.User.UserProfile.postCode }}</span>
              </div>
              <div class="font-weight-bold">{{ order.User.UserProfile.phone }}</div>
            </div>
            <v-btn class="primary lighten-4" outlined block @click="addUser" v-if="!order.User.id">
              <v-icon>mdi-plus</v-icon> Add new customer
            </v-btn>
            <v-row class="px-3" v-else>
              <v-btn outlined  @click="editUser(order.User)">
                Edit
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn outlined  @click="resetOrderUser">
                Change
              </v-btn>
              <v-spacer v-if="$route.params.id"></v-spacer>
              <v-btn outlined v-if="$route.params.id"  @click="printLabel">
                Print
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-simple-table class='grey lighten-4'>
          <thead>
            <tr>
              <th>Product Name</th>
              <th class="text-right">Quantity</th>
              <th class="text-right">Price</th>
              <th class="text-right" style="width:124px;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in order.OrderItems" :key="item.id">
              <td class="py-2">
                <div>{{ item.productName }}</div>
                <span v-if="item.serial">No. seri: {{ item.serial }}<span v-if="item.license"> &mdash; </span></span>
                <span v-if="item.license">Lisensi: {{ item.license }}</span>
                <div v-if="item.note">{{ item.note }}</div>
              </td>
              <td class="text-right">
                {{ item.quantity }}
              </td>
              <td class="text-right">
                {{ $toMoney(item.price) }}
              </td>
              <td class="text-right">
                <v-btn color="primary" icon @click="editLineItem(item, idx)" class="mx-1"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn color="red" icon @click="deleteItem(idx)" class="mx-1"><v-icon>mdi-delete</v-icon></v-btn>
              </td>
            </tr>

            <tr>
              <td colspan="4">
                <v-btn   color="success" @click="addLineitem">
                  <v-icon>mdi-plus</v-icon>Add product
                </v-btn>
              </td>
            </tr>
          </tbody>
          <tfoot class="grey lighten-2">
            <tr>
              <td colspan="2" class="text-right font-weight-bold">
                TOTAL
              </td>
              <td class="text-right font-weight-bold">
                {{ $toMoney(order.amount) }}
              </td>
              <td>
                &nbsp;
              </td>
            </tr>
          </tfoot>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  x-large color="primary" @click="saveOrder">{{ orderSaveBtn }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-sheet class="primary lighten-4 pa-6" style="width:400px;" v-if="order.id">
      <v-card class="mx-3">
        <v-card-text>
          <div>Ship to: {{ order.shipTo.name }}</div>
          <div>Ship to: {{ order.shipTo.address }}</div>
          <div>Ship to: {{ order.shipTo.phone }}</div>
        </v-card-text>
      </v-card>
    </v-sheet>



    <UserDialog ref="user" @closeDialog="closeDialogUser"></UserDialog>
    <LineitemDialog ref="lineitem" :item="lineitem" @closeDialog="closeDialogLineitem"></LineitemDialog>

    <v-sheet ref="prinIt">
      <div style="font-size:14px;line-height: 1.4em;font-family:Arial;">
        <div v-if="$route.params.id">
          <div><strong>Kepada: {{ order.shipTo.name }}</strong></div>
          <div>{{ order.shipTo.address }}</div>
          <div>HP: {{ order.shipTo.phone }}</div>
        </div>
        <v-divider style="margin: 1em 0;color:#ccc;"></v-divider>
        <div style="">
          <div>Sip: jasmadigital.com &mdash; 0812.2806.2725</div>
          <div>Via: <strong>{{ order.courier }}</strong> <span v-if="order.booking">&mdash; Booking: <strong>{{ order.booking }}</strong></span></div>
        </div>

        <v-divider style="margin:1em 0;"></v-divider>
        <div v-for="(item, idx) in order.OrderItems.filter(i => i.serial )" :key="idx" >
          <div>{{ item.productName }}</div>
          <div>
            <span>No.Seri: <strong> {{ item.serial }} </strong></span>
            <span> &mdash; Lisensi: <strong> {{ item.license }} </strong></span>
          </div>

          <v-divider style="margin:1em 0" v-if="idx < order.OrderItems.length - 1 "></v-divider>
        </div>
      </div>
    </v-sheet>


  </v-container>
</template>

<script>
  import UserDialog from '@/components/nano/UserDialog'
  import LineitemDialog from '@/components/nano/LineitemDialog'
  export default {
    components: { UserDialog, LineitemDialog },
    data(){
      return {
        datePicker: false,
        order: { amount: 0, shipTo: {}, date: this.$moment().format('YYYY-MM-DD'), OrderItems: [],
          User: { email:'', UserProfile: { name: '', city: { type: '' } } }
        },
        lineitem: {},
        editedIndex: -1,
        dialogDatePicker: false,
        couriers: [ 'TIKI Eco', 'TIKI Reg', 'TIKI ONS', 'JNE Reg', 'JNE YES', 'SiCepat', 'AnterAja', 'Pos Kilat', 'Pos Express', 'J & T Reguler' ]
      }
    },

    created(){
      if(this.$route.params.id) {
        this.getOrder()
      }
    },

    computed:{
      orderSaveBtn(){
        return (!this.$route.params.id) ? 'Save' : 'Update'
      },
      filteredUsers(){
        return this.$store.state.users
      },

      orderAmount(){
        return this.order.OrderItems.reduce((a,b) => (a + b.price),0)
      },

      shipTo(){
        const postCode = (this.order.User.UserProfile.postCode) ? ', ' + this.order.User.UserProfile.postCode: ''
        const shipTo = {
          name: this.order.User.UserProfile.name,
          address: this.order.User.UserProfile.address +', '+ this.order.User.UserProfile.city.city + postCode,
          phone: this.order.User.UserProfile.phone
        }
        return shipTo
      },

      orderDateFormat(){
        return (this.order.date) ? this.$moment(this.order.date).format('L') : ''
      },

    },

    watch:{
      orderAmount(val){
        this.order.amount = val
      },
    },

    methods:{
      resetOrderUser(){
        this.order.User = { email:'', UserProfile: { name: '', city: { type: '' } } }
      },
      getOrder(){
        this.axios.get('/orders/' + this.$route.params.id).then( (res) => {
          this.order = res.data
        })
      },

      addUser(){
        this.$refs.user.dialogUser = true
      },

      editUser(){
        this.$refs.user.dialogUser = true
        this.$refs.user.editedUser = JSON.parse(JSON.stringify(this.order.User))
      },

      getUserId(id){
        this.order.userId = id
      },

      closeDialogUser(user){
        this.$refs.user.dialogUser = false
        this.order.User = user
        this.$refs.user.editedUser = { email: '', UserProfile: { city: { type: '' } } }
      },

      addLineitem(){
        this.$refs.lineitem.dialogLineitem = true
      },

      editLineItem(item, idx){
        this.$refs.lineitem.dialogLineitem = true
        this.$refs.lineitem.assignItem(item)
        this.editedIndex = idx
        this.$refs.lineitem.selectedProduct = this.$store.state.products.filter(i => i.id == item.productId)[0]
      },

      deleteItem(idx){
        this.order.OrderItems.splice(idx,1)
        if(this.order.id){
          this.axios.delete('/orderitems/'+ this.order.OrderItems[idx].id).then( ()=>{

          }).catch(() => {})
        }
      },

      closeDialogLineitem(item){
        if(!item) return
        this.$refs.lineitem.dialogLineitem = false
        if(this.editedIndex == -1){
          this.order.OrderItems.push(item);
          if(this.order.id){
            item.orderId = this.order.id
            this.axios.post('/orderitems', item).then( () => {
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Success', value:true } })
            }).catch((err) => {
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
            })
          }
        } else {
          this.order.OrderItems.splice( this.editedIndex , 1, item)
          if(this.order.id){
            item.orderId = this.order.id
            this.axios.put('/orderitems/'+ this.order.OrderItems[this.editedIndex].id, item).then( () => {
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Success', value:true } })
            }).catch( (err) => {
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
            })
          }
          this.editedIndex = -1
        }

      },

      saveOrder(){
        this.order.shipTo = this.shipTo
        if(!this.$route.params.id){
          this.axios.post('/orders', this.order).then( (res) => {
            this.$router.push('/order/'+ res.data.id)
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Success', value:true } })
          }).catch( (err) => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
          })
        } else {
          this.axios.put('/orders/'+ this.$route.params.id, this.order).then( () => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Success', value:true } })
          }).catch( (err) => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
          })
        }

      },

      printLabel(){
        // this.dialogPrintLabel = true
            // window.open('', '', 'height=500, width=500');
            // var divContents = window.getElementById("printIt").innerHTML;
            var divContents = this.$refs.prinIt.$el.innerHTML;

            var a = window.open('', '', 'height='+ screen.height +', width='+ screen.height);
            a.document.write('<html><body>');
            a.document.write(divContents);
            a.document.write('</body></html>');
            a.document.close();
            // a.print();

        // setTimeout(() =>{
        //   window.print();
        //     this.dialogPrintLabel = false
        // }, 200)

      }

    }
  }
</script>

<style scoped>
  .border-1 { border:1px solid #000; }

</style>
